/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Erp_QInputs */



/**
* | output |
* | --- |
* | "What is the ERP file?" |
*
* @param {Partner_Faq_Erp_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_erp_q = /** @type {((inputs?: Partner_Faq_Erp_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Erp_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was ist die ERP-Datei?")
	return /** @type {LocalizedString} */ ("What is the ERP file?")
});